import type { AiInsightResponse } from '../../lib/types';
import { withDisplayNames } from '../../lib/foodDisplayName';
import { InsetGroup, SectionHeader } from './insightsUi';

export interface WeeklyPlanListProps {
  plan: AiInsightResponse['plan'];
}

/** "This week's plan": numbered rows of title and one-line detail. */
export function WeeklyPlanList({ plan }: WeeklyPlanListProps) {
  if (plan.length === 0) return null;
  return (
    <section>
      <SectionHeader>This week&apos;s plan</SectionHeader>
      <InsetGroup>
        <ol>
          {plan.map((step, i) => (
            <li
              key={`${i}-${step.title}`}
              className="px-4 py-3 border-t border-slate-200 dark:border-zinc-800 first:border-t-0"
            >
              <div className="text-base text-slate-950 dark:text-white">
                {i + 1}. {withDisplayNames(step.title, step.items)}
              </div>
              {step.detail && (
                <div className="text-[0.8125rem] leading-snug text-slate-500 dark:text-zinc-400">
                  {withDisplayNames(step.detail, step.items)}
                </div>
              )}
            </li>
          ))}
        </ol>
      </InsetGroup>
    </section>
  );
}
